import React from 'react'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'

import Index from '~/webhooks/pages/index.jsx'
import NoMatch from '~/webhooks/pages/no_match.jsx'
import Subscription from '~/webhooks/pages/subscription.jsx'
import NewSubscription from '~/webhooks/pages/new_subscription.jsx'
import EditSubscription from '~/webhooks/pages/edit_subscription.jsx'

export default class Webhooks extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Index} />
          <Route
            exact
            path="/subscriptions/edit"
            component={EditSubscription}
          />
          <Route exact path="/subscriptions/new" component={NewSubscription} />
          <Route
            path="/subscriptions/:subscriptionId"
            component={Subscription}
          />
          <Route component={NoMatch} />
        </Switch>
      </Router>
    )
  }
}
